﻿/*
    Import all individual JS into a single bundle
*/

import "jquery";
// import '@fancyapps/fancybox/dist/jquery.fancybox';
import "bootstrap/dist/js/bootstrap";
import "popper.js/dist/esm/popper";
import { initContactForm } from "./contactform";
import { initMenu } from "./menu";

initContactForm();
initMenu();
